// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"uP-z","upvoteIcon":"vP-z","downvoteIcon":"wP-z","feedbackIcon":"xP-z"};